import React from 'react';
import AboutHero from '../components/common/AboutHero';
import Recete3 from '../assets/images/recete3.jpg';
import AboutIntro from '../components/layout/hakkimizda/AboutIntro';
import MegaParkLogo from '../assets/images/megapark.png';
import FeaturesRow, { FeatureItem } from '../components/layout/hakkimizda/FeaturesRow';
import DoctorsGrid from '../components/layout/DoctorsGrid';
import DoctorsStage from '../components/layout/hakkimizda/DoctorsStage';
import FeedbackSection from '../components/layout/hakkimizda/FeedbackSection';
import ContactStrip  from '../components/common/ContactStrip';
import { toUrl } from '../lib/config';
import DilediginizDoktor from "../assets/images/dilediginiz-doktor.png";
import Ambulans from "../assets/images/ambulans.png";
import Canta from "../assets/images/canta.png";



const HakkimizdaPage: React.FC = () => {
  // Defaults (yalnızca API boş dönerse kullan)
  const DEFAULT_HERO = {
    kicker: 'Hakkımızda',
    title: 'Biz Kimiz?',
    description: 'Sağlığınıza adanmış bir ekibiz. Deneyimli ve uzman kadromuzla hastalarımızın sağlığını koruma ve geliştirmeye odaklanıyoruz. Hasta memnuniyeti ve güveni bizim için en önemli değerlerdir.',
  };
  const DEFAULT_INTRO = {
    aboutTitle: 'Megapark Hastanesi',
    aboutText: [
      'Megapark Hastanesi, 2014 yılında kurulmuş bulunan Marsam Özel Sağlık Hizmetleri A.Ş’nin sağlık hizmetleri projesidir. Hastane binası inşaatı ve medikal cihazlar tamamlanarak 2015 yılının Ocak ayında hasta kabule başlanmıştır.',
      'Megapark Hastanesi gelişmiş tıp teknolojisinin yanında üstün bilgi ve yetenekteki uzman kadrosu ile sağlık hizmetleri alanında hizmet sunmaktadır. ...',
      'Poliklinik hizmetleri Sabah 08:00 Akşam 17:00 arasında alınabilir. Cumartesi günü ise 08:00–12:00 arası muayene yapılmaktadır.',
    ],
    logoSrc: MegaParkLogo,
    valuesKicker: 'BİZİM İÇİN ÖNEMLİSİNİZ',
    valuesTitleGreen: 'Temel',
    valuesTitleMain: 'Değerlerimiz',
    valuesText: 'Hastanemiz hastalarına üst düzey hizmet ve değer vermektedir. Kendinizi değerli hissetmeniz için Megapark Hastanesi her zaman yanınızda.',
  };

  // AboutHero dynamic (başta boş, API gelince doldur)
  const [heroKicker, setHeroKicker] = React.useState<string>('');
  const [heroTitle,   setHeroTitle]   = React.useState<string>('');
  const [heroDesc,    setHeroDesc]    = React.useState<string>('');
  const [heroLoading, setHeroLoading] = React.useState<boolean>(true);

  // AboutIntro dynamic content (başta boş, API gelince doldur)
  const [aiAboutTitle, setAiAboutTitle] = React.useState<string>('');
  const [aiAboutText, setAiAboutText] = React.useState<string[]>([]);
  const [aiLogoSrc, setAiLogoSrc] = React.useState<string>('');
  const [aiValuesKicker, setAiValuesKicker] = React.useState<string>('');
  const [aiValuesTitleGreen, setAiValuesTitleGreen] = React.useState<string>('');
  const [aiValuesTitleMain, setAiValuesTitleMain] = React.useState<string>('');
  const [aiValuesText, setAiValuesText] = React.useState<string>('');
  const [introLoading, setIntroLoading] = React.useState<boolean>(true);

  // FeedbackSection defaults and state
  const DEFAULT_FB = {
    titleLight: 'Görüşlerinizi',
    titleAccent: 'Bize Bildirin',
    description:
      'Sizin görüşleriniz bizim için çok önemli. Görüşlerinizi, istek, dilek ve şikayetlerinizi bizimle paylaşın. Sizin memnuniyetiniz öncelikli görevimizdir.',
  };
  const [fbTitleLight, setFbTitleLight] = React.useState<string>('');
  const [fbTitleAccent, setFbTitleAccent] = React.useState<string>('');
  const [fbDescription, setFbDescription] = React.useState<string>('');

  React.useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        setHeroLoading(true);
        const res = await fetch(toUrl('/api/page-hero/hakkimizda'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
        if (!cancelled) {
          setHeroKicker(obj.kicker || '');
          setHeroTitle(obj.title || '');
          setHeroDesc(obj.description || '');
        }
      } catch {
        // ignore
      }
      finally { if (!cancelled) setHeroLoading(false); }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  // Fetch FeedbackSection content
  React.useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const res = await fetch(toUrl('/api/feedback-section'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
        if (cancelled) return;
        setFbTitleLight(obj.titleLight || '');
        setFbTitleAccent(obj.titleAccent || '');
        setFbDescription(obj.description || '');
      } catch {
        // keep empty -> render will fallback to defaults
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  // Fetch AboutIntro content
  React.useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        setIntroLoading(true);
        const res = await fetch(toUrl('/api/page-about-intro/hakkimizda'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
        if (cancelled) return;
        setAiAboutTitle(obj.aboutTitle || '');
        setAiValuesKicker(obj.valuesKicker || '');
        setAiValuesTitleGreen(obj.valuesTitleGreen || '');
        setAiValuesTitleMain(obj.valuesTitleMain || '');
        setAiValuesText(obj.valuesText || '');
        // aboutText array of objects -> strings array sorted by orderIndex
        if (Array.isArray(obj.aboutText)) {
          const lines = obj.aboutText
            .slice()
            .sort((a: any, b: any) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0))
            .map((x: any) => x.text || '')
            .filter((s: string) => s && s.trim());
          setAiAboutText(lines);
        }
        // logoUrl normalize
        if (obj.logoUrl) {
          const raw: string = obj.logoUrl;
          const normalized = /^https?:\/\//i.test(raw)
            ? raw
            : (raw.startsWith('/api/') ? raw : `/api/media/${raw}`);
          setAiLogoSrc(toUrl(normalized));
        }
      } catch {
        // ignore
      }
      finally { if (!cancelled) setIntroLoading(false); }
    };
    run();
    return () => { cancelled = true; };
  }, []);
  
  const data: FeatureItem[] = [
    {
      title: "Dilediğiniz Doktor",
      description:
        "Hastanemizde dilediğiniz hekimden hizmet alabilirsiniz. Doktor sizi değil; siz doktorunuzu seçin.",
      // 1) ReactNode ikon
      icon: (
        <img src={DilediginizDoktor} alt="Dilediğiniz Doktor" />
      ),
    },
    {
      title: "Acil Servis",
      description:
        "7/24 hizmetimizde olan hastanemiz tam teşekküllü Acil Servisi ile her an yanınızda.",
      // 2) IMG olarak ver (CDN / public klasörü)
      icon: (<img src={Ambulans} alt="Ambulans" />),
    },
    {
      title: "Sizin İçin Buradayız",
      description:
        "Uzman doktor ve hemşirelerimizle güler yüzlü hizmetinizdeyiz.",
      // icon: <FamilyIcon />, // SVGR ile
      icon: (
        <img src={Canta} alt="Canta" />
      ),
    },
  ];

  const [doctors, setDoctors] = React.useState<Array<{ id: string | number; name: string; subtitle: string; photo: string; icon: React.ReactNode }>>([]);
  const [loadingDoctors, setLoadingDoctors] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        setLoadingDoctors(true);
        const res = await fetch(toUrl('/api/doctors/random?limit=4'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const mapped = (Array.isArray(data) ? data : []).map((d: any, idx: number) => {
          const raw = d.portraitUrl || '';
          const normalized = /^https?:\/\//i.test(raw)
            ? raw
            : (raw.startsWith('/api/') ? raw : (raw ? `/api/media/${raw}` : ''));
          return ({
            id: d.id || idx,
            name: d.name || '',
            subtitle: d.shortTitle || '',
            photo: toUrl(normalized),
            icon: <span className="bi bi-gender-female"></span>,
          });
        });
        if (!cancelled) setDoctors(mapped);
      } catch {
        // leave empty
      } finally {
        if (!cancelled) setLoadingDoctors(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  const SendFeedback = async (data: any) => {
    try {
      const payload = {
        name: data?.name ?? '',
        email: data?.email ?? '',
        subject: data?.subject ?? '',
        message: data?.message ?? '',
      };
      const res = await fetch(toUrl('/api/feedback-messages'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error('submit_failed');
      // İstersen burada başarı geri bildirimi verebilirsin
      console.log('Feedback gönderildi:', payload);
    } catch (e) {
      console.error('Feedback gönderilemedi', e);
    }
  }


  

  return (
    <>
      {heroLoading ? (
        <section style={{ padding: '24px 0', textAlign: 'center', color: '#6b7280' }}>Başlık yükleniyor…</section>
      ) : (
        <AboutHero
          image={Recete3}
          kicker={heroKicker || DEFAULT_HERO.kicker}
          title={heroTitle || DEFAULT_HERO.title}
          description={heroDesc || DEFAULT_HERO.description}
          overlayColor="#2cadd2"
          overlayOpacity={0.72}
          accentColor="#e30613"
          textColor="#2b2b2b"
          focus="center center"
          align="center"
          desktopHeight={460}
          tabletHeight={380}
          mobileHeight={320}
        />
      )}

      {introLoading ? (
        <section style={{ padding: '16px 0', textAlign: 'center', color: '#6b7280' }}>Hakkımızda içerik yükleniyor…</section>
      ) : (
        <AboutIntro
          aboutTitle={aiAboutTitle || DEFAULT_INTRO.aboutTitle}
          aboutText={(aiAboutText && aiAboutText.length) ? aiAboutText : DEFAULT_INTRO.aboutText}
          logoSrc={aiLogoSrc ? aiLogoSrc : DEFAULT_INTRO.logoSrc}
          valuesKicker={aiValuesKicker || DEFAULT_INTRO.valuesKicker}
          valuesTitleGreen={aiValuesTitleGreen || DEFAULT_INTRO.valuesTitleGreen}
          valuesTitleMain={aiValuesTitleMain || DEFAULT_INTRO.valuesTitleMain}
          valuesText={aiValuesText || DEFAULT_INTRO.valuesText}
          green="#2ba87a
"
          text="#2b2b2b"
        />
      )}

      <div>
        <FeaturesRow
          items={data}
          accentColor="#2ba87a"   // ikon rengi (opsiyonel)
          textColor="#2b2b2b"     // başlık rengi (opsiyonel)
          mutedColor="#666"       // açıklama rengi (opsiyonel)
        />
      </div>

      <DoctorsStage
        bgImage="/assets/images/doctor-bg.jpg"
        overlay="rgba(7, 42, 84, .78)"   // istersen linear-gradient de kullanabilirsin
        maxWidth={1200}
        colsDesktop={4}
        colsTablet={2}
        colsMobile={1}
        paddingY="clamp(56px, 8vw, 120px)"
        ctaText="Tüm Hekimler"
        onCtaClick={() => (window.location.href = "/hekimler")}
        showCta={true}
      >
        {loadingDoctors ? (
          <div style={{ padding: '16px 0', textAlign: 'center', color: '#6b7280' }}>Hekimler yükleniyor…</div>
        ) : (
          <DoctorsGrid items={doctors} />
        )}
      </DoctorsStage>

      <FeedbackSection
        titleLight={fbTitleLight || DEFAULT_FB.titleLight}
        titleAccent={fbTitleAccent || DEFAULT_FB.titleAccent}
        description={fbDescription || DEFAULT_FB.description}
        mapSrc='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.3583965308617!2d36.9591286!3d37.5701775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x152de786eb8c813f%3A0xae5e14dbc0c189d6!2s%C3%96zel%20MegaPark%20Hastanesi!5e0!3m2!1str!2str!4v1759780781173!5m2!1str!2str'
        // mapSrc="https://www.google.com/maps?q=%C3%96zel%20MegaPark%20Hastanesi%2C%20Dulkadiro%C4%9Flu%2C%20Kahramanmara%C5%9F&hl=tr&z=16&output=embed" // kendi embed URL'inizi koyun
        onSubmit={(data: any) => SendFeedback(data)}
        accentColor="#2cadd2"  // istersen tema rengi değiştir
        maxWidth={1200}
      />


      <ContactStrip />
    </>
  );
};

export default HakkimizdaPage;
